import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '@/components/Icon';
import Topbar from '@/layout/Topbar';
import { useShell } from '@/layout/AppShell';

/**
 * Каталог отчётов учителя. Структура — как у админских отчётов
 * (`pages/reports/ReportsIndex`), но список значительно уже: учитель
 * видит только то, что относится к нему самому. По мере появления новых
 * учительских отчётов — расширяем GROUPS.
 */
const GROUPS = [
  {
    title: 'Дополнительные занятия',
    items: [
      {
        id:    'extras-monthly',
        title: 'Проведённые дополнительные занятия за месяц',
        desc:  'Сводка проведённых вами доп. занятий за выбранный месяц: индивидуальные с разбивкой по ученикам и групповые с разбивкой по слотам, с суммой к выплате.',
        to:    '/teacher/reports/extras-monthly',
      },
    ],
  },
];

export default function TeacherReportsPage() {
  const { tweaks, updateTweak } = useShell();
  return (
    <>
      <Topbar
        breadcrumb={['Разное', 'Отчёты']}
        density={tweaks.density}
        onDensityChange={(d) => updateTweak('density', d)}
      />
      <div className="reports-page">
        {GROUPS.map((g) => (
          <section key={g.title} className="reports-group">
            <h2 className="reports-group__title">{g.title}</h2>
            <div className="reports-group__list">
              {g.items.map((it) => (
                <Link key={it.id} to={it.to} className="reports-card">
                  <span className="reports-card__icon"><Icon name="chart" size={18} /></span>
                  <div className="reports-card__body">
                    <div className="reports-card__title">{it.title}</div>
                    <div className="reports-card__desc">{it.desc}</div>
                  </div>
                  <span className="reports-card__arrow"><Icon name="chevron" size={14} /></span>
                </Link>
              ))}
            </div>
          </section>
        ))}
      </div>
    </>
  );
}
